require('../../modules/es.object.assign');

module.exports = require('../../internals/path').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/es/object/assign.js
// module id = 548
// module chunks = 0